
import { DateValue } from "@cirrus/core/dateTime/types/DateValue"
import { FriendlyDateFormat } from "@cirrus/core/dateTime/types/FriendlyDateFormat"
import { useTranslations } from "@cirrus/core/i18n/provider"

import { useUserSettings } from "../UserSettings"
import { formatDate, formatRelative } from "../src/_legacy"

export const useDateFormat = () => {

  const { i18n } = useTranslations()
  const {
    state: {
      regs: {
        formats: localeDataFormat,
        stformat: userTimeFormat,
        zone
      }
    }
  } = useUserSettings()

  /**
   * @deprecated This should not be used, use useDateUserFriendly.ts
   */

  const formatDateUserFriendly = (date: DateValue): FriendlyDateFormat => {
    if (!date) return {
      dtFull: i18n("General:Never"),
      dtRelative: i18n("General:Never")
    }
    const dtFull = formatDate(date, "short")
    const dtRelative = formatRelative(date)
    return { dtFull, dtRelative }
  }

  const formatDateAccordingRegionalSettings = (date: DateValue): string => {
    // TODO remove moment
    const dateFormat = moment().localeData(localeDataFormat)._longDateFormat.L
    return moment(date).tz(zone).format(`${dateFormat}, ${userTimeFormat}`)
  }

  return {
    formatDateUserFriendly,
    formatDateAccordingRegionalSettings
  }
}
